import React from 'react';

import { AuthProviderContext } from './AuthProvider.context';

import type { AuthContextProperties } from './AuthProvider.types';

export const useAuth = (): AuthContextProperties => {
  const context = React.useContext(AuthProviderContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
